import { GridOptions } from 'ag-grid-community'
import { useCallback } from 'react'
import { useDialogState } from '../../../components/dialogs/useDialogState'
import { exportExcel } from '../../../containers/BulkSheet/excel'

export const useExcel = (gridOptions: GridOptions | undefined) => {
  const [dialogOpen, openDialog, closeDialog] = useDialogState()

  const onExportExcel = useCallback(
    (selectedColIds: string[]) => {
      if (!gridOptions) return
      exportExcel({
        fileNamePrefix: 'TaskActualWorkApprovalStatus',
        gridOptions,
        exportColIds: selectedColIds,
      })
      closeDialog()
    },
    [gridOptions, closeDialog]
  )

  return {
    dialogOpen,
    openDialog,
    closeDialog,
    onExportExcel,
  }
}
